import axiosInstance from "./axiosInstance";


export const authService = {
    login(login: string, password: string) {
        return axiosInstance.post(`api/auth/token`, {login, password}).then(res => res.data);
    },
}